import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelComponent {

    @Input() showHeaderToggle = false;
    @Input() hideToggle = false;
    @Input() locked = false;

    @Input() expanded = false;
    @Output() expandedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

}
